import React from "react";
import { connect } from "react-redux";
import { Loading } from "@onelogin/react-components";

import Background from "./Background";
import BrandedContent from "./BrandedContent";
import AppWindow from "./AppWindow";
import OneTrust from "./OneTrust/OneTrust";

const App = ({ branding, ready }) => {
  if (!ready) {
    return <Loading />;
  }
  return (
    <OneTrust cookieManagementEnabled={branding.common.cookie_management_enabled}>
      <Background
        imageUrl={branding.login.background.image_url}
        overlayColor={branding.login.background.overlay_color}
        overlayOpacity={branding.login.background.opacity}
      />
      <BrandedContent
        primaryColor={branding.common.primary_color}
        accentColor={branding.common.accent_color}
      >
        <AppWindow
          logoUrl={branding.common.logo_url}
        />
      </BrandedContent>
    </OneTrust>
  );
};

const mapStateToProps = state => ({
  ready: state.registration.loaded && state.branding.loaded,
  branding: state.branding.data
});

export default connect(mapStateToProps)(App);
